<template>
  <div class="gray-back" style="height: 100%">
    <div class="box">
      <div style="padding-top: .2rem"></div>
      <div v-for="(item,k) in list" :key="k">
        <van-divider>{{item.name}}</van-divider>
        <div v-if="item.name=='过往经历'">
          <van-collapse v-model="activeIndex">
            <van-collapse-item title="过往经历" name="过往经历">
              <div v-if="item.date.zhicai.length">
                <van-divider>执裁记录</van-divider>
                <van-cell-group v-for="(row,i) in item.date.zhicai" :key="i" >
                  <van-cell title="赛区名称" :value="row.saiqu_name" />
                  <van-cell title="裁判长" :value="row.cpz" />
                </van-cell-group>
              </div>
              <div v-if="item.date.huiyi.length">
                <van-divider>培训记录</van-divider>
                <van-cell-group v-for="(row,i) in item.date.huiyi" :key="i" >
                  <van-cell title="名称" :value="row.name" />
                  <van-cell title="场次名称" :value="row.stationname" />
                </van-cell-group>
              </div>
              <div v-if="item.date.cansai.length">
                <van-divider>参赛记录</van-divider>
                <van-cell-group v-for="(row,i) in item.date.cansai" :key="i" >
                  <van-cell title="赛区名称" :value="row.saiqu_name" />
                  <!--              <van-cell title="裁判长" :value="row.cpz" />-->
                </van-cell-group>
              </div>

            </van-collapse-item>
          </van-collapse>

        </div>

        <div v-else>
          <div v-if="item.list.length">
            <van-cell-group v-for="(row,i) in item.list" :key="i" >
              <div v-if="item.name=='裁判资质'">
                <div class="cert-li">
                  <div style="text-align: center;padding-top: .2rem">{{row.cert.filename}}</div>
                  <img :src="row.cert.img" v-if="row.cert.img" alt="">
                  <img :src="row.cert.img2" v-if="row.cert.img2" alt="">
                  <div class="cert-button">
                    <van-button  v-if="!isApp" @click="download(row.name+'-'+row.grade,row.cert.url)" style="margin: 10px auto; text-align: center " type="default" round>请点击按钮下载</van-button>
                    <van-button v-else @click="download(row.name+'-'+row.grade,row.cert.url)" style="margin: 10px auto; text-align: center " type="default" round>点击下载</van-button>
                  </div>
                </div>
                <!--            <van-cell title="姓名" :value="row.name" />-->
                <!--            <van-cell title="身份证" :value="row.num" />-->
                <!--            <van-cell title="等级" :value="row.grade" />-->
                <!--            <van-cell title="编号" :value="row.code" />-->
                <!--            <van-cell title="日期" :value="row.registdate" />-->
              </div>

              <div v-else-if="item.name=='证书记录'">
                <van-cell title="等级" :value="row.grade" />
                <van-cell title="证书编号" :value="row.code" is-link @click="downloadHistoryPic(row)" />
              </div>
              <div v-else-if="item.name=='执裁记录'">
                <van-cell title="赛区" :value="row.match_name" />
                <van-cell title="裁判长" :value="row.admin_name" />
              </div>
              <div v-else-if="item.name=='培训记录'">
                <van-cell title="日期" :value="row.date" />
                <van-cell title="名称" :value="row.name" />
              </div>

            </van-cell-group>
          </div>

          <div v-else style="text-align: center;padding: 0.2rem;margin: 0 0.2rem;
    background: #fff;border-radius: .2rem">系统中暂无记录</div>

        </div>



      </div>


      <div class="" v-if="emptyShow">
        <van-empty style="margin: 10px auto" description="暂无结果"/>
      </div>
    </div>

    <div style="height: 50px;background: #f8f8f8"></div>

    <div class="savebtn">
      <van-button color="linear-gradient(90deg, rgb(254, 200, 53) 0%, rgb(255, 173, 25) 100%)"
                  style="width: 3rem" round
                  size="normal" v-rblink="{name: 'SaiScoreCaipanApply'}">补交执裁记录
      </van-button>
      <van-button
          color="linear-gradient(90deg, rgb(254, 200, 53) 0%, rgb(255, 173, 25) 100%)"
          style="width: 3rem"
          size="normal" round  v-rblink="{name: 'CertPersonPhoto'}">上传证件照</van-button>

    </div>

  </div>
</template>
<style scoped>
.box {
  /*margin-bottom: 50px;*/
  background: rgba(248, 248, 248, 1);
  min-height: 90vh;
}

.cert-li {
  margin:0 .3rem;
}

.cert-li img {
  width: 100%;
  border-radius: 5px;
}

.cert-button {
  text-align: center;
}

.savebtn {
  position: fixed;
  bottom: 0;
  padding-bottom: 0.2rem;
  width: 100%;
  z-index: 10;
  display: flex;
  flex: 1;
  flex-direction: row;
  justify-content: space-around;
  background: linear-gradient(180deg, hsla(0, 0%, 100%, 0), #fff);
}

.van-pull-refresh {
  margin-top: 0.3rem
}

.title-left span {
  font-size: 14px;
  font-family: PingFangSC-Regular, PingFang SC;
  font-weight: 400;
  color: rgba(0, 0, 0, 1);
}

.normal-btn {
  font-size: 12px;
  font-family: PingFangSC-Regular, PingFang SC;
  font-weight: 400;
  color: rgba(0, 0, 0, 1);
  line-height: 26px;
  width: 75px;
  height: 26px;
  border-radius: 13px;
  border: 1px solid rgba(0, 0, 0, 1);
  margin-right: 0.5rem;
}

.count_edit {
  width: 87px;
  height: 26px;
  background: linear-gradient(90deg, rgba(254, 200, 53, 1) 0%, rgba(255, 173, 25, 1) 100%);
  border-radius: 13px;
  font-size: 12px;
  font-family: PingFangSC-Regular, PingFang SC;
  font-weight: 400;
  color: rgba(255, 255, 255, 1);
  line-height: 26px;
  margin-right: 0.5rem
}

.row-list {
  border-bottom: 0.1rem solid #EFEFEF;
  background: #fff;
  margin: 0.2rem;
  border-radius: 0.2rem;
}

.row-title-img {
  width: 0.4rem;
  height: 0.4rem;
  margin-right: 0.1rem;
}

.row-title {
  padding: 0.1rem 0.33rem;
}

.title-right {
  color: #FD2840;
}


.row-left {
  width: 80%;
}

.row-right {
  text-align: center;
}

.goods-detail {
  width: 72%;
}

.row-left-img {
  width: 1.44rem;
  height: 1.44rem;
  border-radius: 5px;
  margin-right: 0.2rem;
}

.row-goods {
  padding: 0.2rem 0.3rem;
  border-bottom: 1px solid #EFEFEF;
}

.goods-name {
  font-size: 12px;
  margin-bottom: 0.6rem;
}

.goods-price {
  font-size: 16px;
  margin: 0.1rem 0 0.6rem;
  font-family: PingFangSC-Medium, PingFang SC;
  font-weight: 500;
  color: rgba(253, 40, 64, 1);
}

.goods-price span {
  font-size: 12px;
}

.goods-num {
  font-size: 12px;
}

.pay_order {
  width: 87px;
  height: 26px;
  background: linear-gradient(90deg, rgba(254, 200, 53, 1) 0%, rgba(255, 173, 25, 1) 100%);
  border-radius: 13px;
  font-size: 12px;
  font-family: PingFangSC-Regular, PingFang SC;
  font-weight: 400;
  color: rgba(255, 255, 255, 1);
  line-height: 26px;
  margin-right: 0.5rem
}

.row-btn {
  display: flex;
  justify-content: flex-end;
  align-items: center;
  padding: 0.2rem 0.33rem;
  font-size: 12px;
  text-align: center;
  line-height: 0.52rem;
}

.look-order {
  font-size: 12px;
  font-family: PingFangSC-Regular, PingFang SC;
  font-weight: 400;
  color: rgba(0, 0, 0, 1);
  line-height: 26px;
  width: 75px;
  height: 26px;
  border-radius: 13px;
  border: 1px solid rgba(0, 0, 0, 1);
  margin-right: 0.5rem;
}

.invite-btn {
  width: 2.1rem;
  height: 0.52rem;
  background: rgba(255, 0, 0, 1);
  border: 1px solid rgba(255, 0, 0, 1);
  border-radius: 4px;
  color: #fff;
}

</style>

<script>
import Vue from 'vue';

import area from "../../../utils/area";
import validator from "../../../utils/validator";
import {
  Cell, CellGroup, Toast, Dialog, Icon, PullRefresh, List, Tag, Button, DropdownMenu, DropdownItem,
  Tab,
  Tabs,
  NoticeBar, Empty
} from 'vant';
import LoginDialog from '@/components/LoginDialog.vue';

Vue.use(Cell).use(CellGroup).use(Toast).use(Dialog).use(Icon).use(Tag).use(Button).use(DropdownMenu).use(Tab).use(Tabs).use(DropdownItem);
export default {
  name: 'UserSearchCaipan',
  components: {
    [PullRefresh.name]: PullRefresh,
    [List.name]: List,
    [Empty.name]: Empty,
    LoginDialog,
  },
  data: function () {
    return {
      validator,
      activeNames: [],
      isSubmit: false,
      loginShow: false,
      emptyShow: false,
      showYewuPicker: false,
      showSubPicker: false,
      showArea: false,
      areaList: {},
      saveLoading: false,
      active: 0,
      activeIndex: [],
      activeIndex2: [],
      isLoading: false,
      loading: false,
      finished: false,
      params: {
        pageNo: 1,
        pageSize: 5,
        status: 0
      },
      homeTop: 0,
      list: [],
      list2: [],
      yewuColumns: [
        '教练员', '裁判员', '达标人员', '技术等级运动员', '七彩星级运动员', '导师团队', '考官', '监督', '培训师'
      ],
      subColumns: [],
      subOptions: [
        {
          name: '等级',
          list: [
            {
              name: '舞蹈一级',
              value: 1,
            },
            {
              name: '舞蹈二级',
              value: 2,
            },
            {
              name: '舞蹈三级',
              value: 3,
            },
            {
              name: '舞蹈高级',
              value: 4,
            },
            {
              name: '舞蹈国家级',
              value: 5,
            },

            {
              name: '技巧一级',
              value: 6,
            },
            {
              name: '技巧二级',
              value: 7,
            },
            {
              name: '技巧三级',
              value: 8,
            },
            {
              name: '技巧高级',
              value: 9,
            },
            {
              name: '技巧国家级',
              value: 10,
            },
          ]
        },

        {
          name: '等级',
          list: [
            {
              name: '舞蹈一级',
              value: 1,
            },
            {
              name: '舞蹈二级',
              value: 2,
            },
            {
              name: '舞蹈三级',
              value: 3,
            },
            {
              name: '舞蹈国家级',
              value: 4,
            },
            {
              name: '舞蹈国际级',
              value: 5,
            },

            {
              name: '技巧一级',
              value: 6,
            },
            {
              name: '技巧二级',
              value: 7,
            },
            {
              name: '技巧三级',
              value: 8,
            },
            {
              name: '舞蹈国家级',
              value: 9,
            },
            {
              name: '舞蹈国际级',
              value: 10,
            },
          ]
        }, {
          name: '',
          list: []
        }, {
          name: '',
          list: []
        }, {
          name: '',
          list: []
        }, {
          name: '',
          list: []
        }, {
          name: '',
          list: []
        }, {
          name: '',
          list: []
        }, {
          name: '',
          list: []
        }
      ],
      formData: {
        yewuIndex: 1,
        yewuName: '教练员',
        subName: '',
        subValue: '',
      },
      subColums: [],
      subLabel: "",
      isApp: window.isApp()
    }
  },
  mounted() {
    let that = this;
    document.title = "裁判查询"
    that.areaList = area;
    that.formData.yewuName = this.yewuColumns[0];
    that.subLabel = this.subOptions[0].name;
    that.formData.subName = this.subOptions[0].list[0].name;
    that.formData.subValue = this.subOptions[0].list[0].value;
    that.subColumns = this.subOptions[0].list.map(item => {
      return item.name
    });

    that.fetch()
  },
  destroyed() {
  },
  methods: {
    fetch() {
      let that = this
      Toast.loading({
        duration: 0, // 持续展示 toast
        message: '查询中...',
        forbidClick: true,
      });

      that.$api.post('/api/cha/caipanCert', {
        name: that.formData.name,
        num: that.formData.num,
      }, (res) => {
        if (res.data) {
          that.list = res.data;
          if (res.data.length == 0) {
            that.emptyShow = true;
          } else {
            that.emptyShow = false;
          }
        }

        Toast.clear()
        that.isSubmit = true;
      }, (res) => {
        Toast.fail(res.msg);
        Toast.clear()
      })
    },

    download(name, url){
      // 判断如果是PDF文件 直接在页面中打开 vue-pdf??

      appEvent({
        name: 'downloadFile',
        query: {
          name:name,
          url:url,
        }
      });
    },

    onSubmit(values) {
      console.log('onSubmit-values', values);
      let that = this;
      console.log(that.formData)
      that.formValidate = true;

      Toast.loading({
        duration: 0, // 持续展示 toast
        message: '查询中...',
        forbidClick: true,
      });

      that.$api.post('/api/cha/caipanCert', {
        name: that.formData.name,
        num: that.formData.num,
      }, (res) => {
        if (res.data) {
          that.list = res.data;
          if (res.data.length == 0) {
            that.emptyShow = true;
          } else {
            that.emptyShow = false;
          }
        }

        Toast.clear()
        that.isSubmit = true;
        that.saveLoading = false;
      }, (res) => {
        Toast.fail(res.msg);
        that.saveLoading = false;
      })
    },
    onSubmit2(values) {
      console.log('onSubmit-values', values);
      let that = this;
      console.log(that.formData)
      that.formValidate = true;
      for (let field in that.formData) {
      }
      if (!that.formData.area) {
        Toast.fail('请选择地区');
        return;
      }
      that.saveLoading = true;

      that.$api.post('/api/cha/personArea', that.formData, (res) => {
        if (res.data) {
          that.list2 = res.data;
          if (res.data.length == 0) {
            that.emptyShow = true;
          } else {
            that.emptyShow = false;
          }
        }
        that.isSubmit = true;
        that.saveLoading = false;
      }, (res) => {
        Toast.fail(res.msg);
        that.saveLoading = false;
      })
    },

    appDownload(name, url){
      let that = this;
      console.log('downloadPic');
      appEvent({
        name: 'downloadPic',
        query: {
          filename: name,
          url:url,
        }
      });
    },

    onRefresh() {
      let that = this;
      that.params.pageNo = 1;
      that.getList();
    },
    downloadHistoryPic(row){
      if(!row.cert_url){
        Toast.fail('证书未生成，请联系管理员');
        return ;
      }

      appEvent({
        name: 'downloadFile',
        query: {
          name: 'xxx',
          url: 'https://ccago.oss-cn-hangzhou.aliyuncs.com/api.ccachina.net/cert/cp/caipan'+row.id+'-'+row.grade+'.jpg',
        }
      });

      return ;

    },


    // 更改状态
    onStatusChange(index) {

      let that = this;
    },
    onYewuConfirm(value, index) {
      this.formData.yewuName = value;
      this.formData.yewuIndex = index + 1;
      this.subColumns = this.subOptions[index].list.map(item => {
        return item.name
      });
      this.subLabel = this.subOptions[index].name;
      if (this.subOptions[this.formData.yewuIndex - 1].list.length > 0) {
        this.formData.subName = this.subOptions[this.formData.yewuIndex - 1].list[0].name;
        this.formData.subValue = this.subOptions[this.formData.yewuIndex - 1].list[0].value
      } else {
        this.formData.subName = '';
        this.formData.subValue = 0;
      }
      this.showYewuPicker = false;
    },

    onSubConfirm(value, index) {
      this.formData.subName = value;
      this.formData.subValue = this.subOptions[this.formData.yewuIndex - 1].list[index].value
      this.showSubPicker = false;
    },

    onFailed(errorInfo) {
      console.log('failed', errorInfo);
    },

  }
}
</script>



// WEBPACK FOOTER //
// UserSearchCaipan.vue?da53d104